import React, { useState, useCallback } from 'react'
import { Routes, Route } from 'react-router-dom'
import Dashboard from './Manager/Dashboard'
import HomePage from './Public/Home'
import RestaurantDetailsPage from './Public/SingleRest/RestaurantDetailsPage'
import SearchResultsPage from './Public/SearchPage'
import ProtectedRoute from '../Context/ProtectedRoute'
import InfoPage from './Policies/AboutAndPolicy'
import AuthFinish from '../AuthFinish'
import SingleArea from './Public/SingleArea/SingleArea'
import AreaRests from './Public/AreaRests'
import ListTop from './Public/List'
import UserProfile from './Profile/UserProfile'
import ClaimStartPage from './Public/SingleRest/ClaimSystem/ClaimStartPage'
import OTPVerifyPage from './Public/SingleRest/ClaimSystem/OTPVerifyPage'
import TransferRequestPage from './Public/SingleRest/ClaimSystem/TransferRequestPage'
import TransferStatusPage from './Public/SingleRest/ClaimSystem/TransferStatusPage'
import ProofUploadPage from './Public/SingleRest/ClaimSystem/ProofUploadPage'
import AcceptStaffInvitePage from './Public/SingleRest/ClaimSystem/AcceptStaffInvitePage'
import HelpCenter from '../Reservation/HelpCenterTab'
import PublicMenuPage from './Manager/Components/EditComponents/PublicMenuPage'

const Body = () => {
  const [headerSearchState, setHeaderSearchState] = useState({
    showSearch: false,
    searchQuery: '',
    isExpanded: false,
    searchSuggestions: [],
    selectedFilters: [],
    onFilterToggle: null
  });

  // Memorize the callback to prevent infinite re-renders
  const handleHeaderSearchChange = useCallback((show, query, isExpanded, suggestions = [], filters = [], filterToggleFn = null) => {
    setHeaderSearchState({
      showSearch: show,
      searchQuery: query,
      isExpanded: isExpanded,
      searchSuggestions: suggestions,
      selectedFilters: filters,
      onFilterToggle: filterToggleFn
    });
  }, []);

  const handleSearchQueryChange = useCallback((query) => {
    setHeaderSearchState(prev => ({
      ...prev,
      searchQuery: query
    }));
  }, []);

  const handleSearchFocus = useCallback(() => {
    setHeaderSearchState(prev => ({
      ...prev,
      isExpanded: true
    }));
  }, []);

  const handleSearchBlur = useCallback(() => {
    setHeaderSearchState(prev => ({
      ...prev,
      isExpanded: false,
      searchQuery: '',
      selectedFilters: []
    }));
  }, []);

  // Only update window state when values actually change
  React.useEffect(() => {
    if (window.updateHeaderSearchState) {
      window.updateHeaderSearchState(headerSearchState, {
        handleSearchQueryChange,
        handleSearchFocus,
        handleSearchBlur
      });
    }
  }, [headerSearchState, handleSearchQueryChange, handleSearchFocus, handleSearchBlur]);

  return (
    <div className='relative min-h-[50vh]'>
        <Routes>
          <Route path='/auth/finish' element={<AuthFinish />} />
            <Route path='/dashboard/*' element=
            {
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
            }
            />
            <Route path='/profile' element={
              <ProtectedRoute>
                <UserProfile />
              </ProtectedRoute>
            }
            />
            <Route 
              path='/' 
              element={
                <HomePage onHeaderSearchChange={handleHeaderSearchChange} />
              } 
            />
            <Route 
              path='/restaurant/:restaurantId' //passed inside the homepage
              element={
                <RestaurantDetailsPage />
              }
            />
            <Route 
              path='/restaurant/:restaurantId/:name' //passed inside the homepage
              element={
                <RestaurantDetailsPage />
              }
            />
            <Route 
              path='/s' //passed inside the homepage
              element={
                <SearchResultsPage />
              }
            />
            <Route 
              path='/prof' //passed inside the homepage
              element={
                <UserProfile />
              }
            />
            <Route 
              path='/areas/:slug' //passed inside the homepage
              element={
                <SingleArea />
              }
            />
            <Route 
              path='/areas/:slug/restaurants'
              element={
                <AreaRests />
              }
            />
            <Route 
              path='/cities/:slug/restaurants'
              element={
                <ListTop />
              }
            />
            <Route 
              path='/about-gemio'
              element={
                <InfoPage />
              }
            />
            <Route path="/menu/:restaurantId" element={<PublicMenuPage />} />
            <Route 
              path='/support'
              element={
                <HelpCenter />
              }
            />
            <Route
              path="/restaurants/:restaurantId/claim"
              element={
              <ProtectedRoute>
                <ClaimStartPage />
              </ProtectedRoute>
            }
            />
            {/* Step 2a: OTP verification */}
            <Route path="/claim/:claimId/verify" element={
              <ProtectedRoute>
                <OTPVerifyPage />
              </ProtectedRoute>
            } />
            {/* Step 2b: proof upload (direct or OTP fallback) */}
            <Route path="/claim/:claimId/proof" element={
              <ProtectedRoute>
                <ProofUploadPage />
              </ProtectedRoute>
            }/>

            {/* ── Transfer flow ────────────────────────────────── */}
            {/* Transfer request form */}
            <Route
              path="/restaurants/:restaurantId/transfer"
              element={
              <ProtectedRoute>
                <TransferRequestPage />
              </ProtectedRoute>
            }
            />
            {/* Transfer status + owner respond + escalate */}
            <Route path="/transfer/:transferId" element={
              <ProtectedRoute>
                <TransferStatusPage />
              </ProtectedRoute>
            } />
            <Route
              path="/restaurant-invite"
              element={
                <ProtectedRoute>
                  <AcceptStaffInvitePage />
                </ProtectedRoute>
              }
            />
        </Routes>
    </div>
  )
}

export default Body
